import { Injectable } from "@angular/core";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { BaseLookupService } from "../../impl/BaseLookupService";
import { IMarketTimeLookupService } from "../IMarketTimeLookupService";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class MarketTimeLookupService extends BaseLookupService<
  string,
  CubiqTS.MarketTimeConstantImpl
> {
  constructor() {
    super(CubiqTS.MarketTimeConstantImpl);
  }

  mapItem(item: CubiqTS.MarketTimeConstantImpl): void {
    super.mapItem(item);
  }

  getItemKey(item: CubiqTS.MarketTimeConstantImpl): string {
    return String(item.id);
  }

  getMarketTime(id: string): CubiqTS.MarketTimeConstantImpl {
    var marketTime = this.getItem(id);
    return marketTime;
  }

  getAllMarketTime(): Array<string> {
    return Array.from((<Map<string, any>>this.myItemMap).keys());
  }
}

//MarketTimeConstantImpl
